/**
 * Localizzazione italiana per i componenti PrimeVue con testo integrato
 * (calendario, filtri di tabella, conferme…). L'app è per utenti italiani
 *: nessuna stringa di libreria deve restare in inglese.
 */
export const localeIt = {
  startsWith: 'Inizia con',
  contains: 'Contiene',
  notContains: 'Non contiene',
  endsWith: 'Finisce con',
  equals: 'Uguale a',
  notEquals: 'Diverso da',
  noFilter: 'Nessun filtro',
  lt: 'Minore di',
  lte: 'Minore o uguale a',
  gt: 'Maggiore di',
  gte: 'Maggiore o uguale a',
  dateIs: 'La data è',
  dateIsNot: 'La data non è',
  dateBefore: 'La data è prima di',
  dateAfter: 'La data è dopo',
  clear: 'Svuota',
  apply: 'Applica',
  matchAll: 'Corrispondenza totale',
  matchAny: 'Corrispondenza parziale',
  addRule: 'Aggiungi regola',
  removeRule: 'Rimuovi regola',
  accept: 'Sì',
  reject: 'No',
  choose: 'Scegli',
  upload: 'Carica',
  cancel: 'Annulla',
  today: 'Oggi',
  weekHeader: 'Sett.',
  firstDayOfWeek: 1,
  dayNames: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
  monthNames: [
    'gennaio',
    'febbraio',
    'marzo',
    'aprile',
    'maggio',
    'giugno',
    'luglio',
    'agosto',
    'settembre',
    'ottobre',
    'novembre',
    'dicembre',
  ],
  monthNamesShort: [
    'gen',
    'feb',
    'mar',
    'apr',
    'mag',
    'giu',
    'lug',
    'ago',
    'set',
    'ott',
    'nov',
    'dic',
  ],
  dateFormat: 'dd/mm/yy',
  emptyMessage: 'Nessun risultato',
  emptyFilterMessage: 'Nessun risultato',
};
